import { computed, ref } from '@vue/composition-api'
import { getConfigKeys } from '../utils/api/config-keys.js'

const configKeysState = ref(null)

let isLoading = false
let isLoadingPromise = null
let isReloading = false
const load = async () => {
	if (isLoading) return
	isLoading = true
	isLoadingPromise = getConfigKeys()
	const configKeysData = await isLoadingPromise
	configKeysState.value = configKeysData.data
	isLoading = false
}

export const waitForLoad = async () => {
	if (isLoadingPromise === null) load()
	return isLoadingPromise
}
export const reloadConfigKeys = async () => {
	if (isReloading) return
	isReloading = true
	try {
		const { data } = await getConfigKeys()
		configKeysState.value = data
	} finally {
		isReloading = false
	}
}

export const configKeys = computed(() => {
	if (configKeysState.value === null) {
		load()
		return {}
	}
	return configKeysState.value
})

export const adminPortalBrandFieldLabel = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'AdminPortalBrandLabel')?.keyValue)
export const noOfAllowedExtendedPrefKeys = computed(() => Number(configKeys.value?.find(({ keyName }) => keyName === 'NoOfAllowedExtendedPrefKeys').keyValue))
export const licenseId = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'LicenseID').keyValue)
export const senderEmailsIdentityLimit = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'SenderEmailsIdentityLimit').keyValue)
export const zohoNewTicketLink = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ZohoNewTicketLink').keyValue)
export const zohoViewTicketLink = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ZohoViewTicketsLink').keyValue)
export const learningHubLink = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'LearningHubLink')?.keyValue)
const statementDrafts = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'StatementDrafts').keyValue.toLowerCase())
const cassieIdentityService = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'IsCISVisibleInAdminPortal').keyValue)
const enableLegacyPermissionsInVue = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'EnableLegacyPermissionsInVuePortal').keyValue.toLowerCase())
export const activeExportsLimit = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ExportsEnabled')?.keyValue)
export const exportsLatestFileSizeLimit = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ExportsLatestFileSizeLimit')?.keyValue)
export const cookieBannerLegacyEmbedCodeVueDisplay = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'CookieBannerLegacyEmbedCodeVueDisplay')?.keyValue.toLowerCase() === 'true')
export const enableCassieCloudEmbedCode = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'EnableCassieCloudEmbedCode')?.keyValue.toLowerCase() === 'true')
export const enableTransactionTypes = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'EnableTransactionTypes')?.keyValue.toLowerCase() === 'true')
export const enableConsentCollectionPreferencePageOptions = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ConsentCollectionPreferencePageOptions')?.keyValue)
export const enableConsentCollectionWidgetOptions = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'ConsentCollectionWidgetOptions')?.keyValue)
export const submissionFragmentsEnabled = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'SubmissionFragmentsEnabled')?.keyValue.toLowerCase() === 'true')
export const dashboardModuleEnabled = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'DashboardModuleEnabled')?.keyValue?.toLowerCase() === 'true')
export const privacyNoticeModuleEnabled = computed(() => configKeys.value?.find(({ keyName }) => keyName === 'PrivacyNoticeModuleEnabled')?.keyValue?.toLowerCase() === 'true')
export const addAdminPortalUserIfNotExist = computed(() =>
	configKeys.value
		?.find(({ keyName }) => keyName === 'AddAdminPortalUserIfNotExist')
		?.keyValue.toLowerCase() === 'true'
)

export const addCSPortalUserIfNotExist = computed(() =>
	configKeys.value
		?.find(({ keyName }) => keyName === 'AddCSUserIfNotExist')
		?.keyValue.toLowerCase() === 'true'
)

export const ssoCspUserIdentityField = computed(() => {
	return configKeys.value
		?.find(({ keyName }) => keyName === 'SSOCsUserIdentityField')
		?.keyValue
})
export const showStatementDrafts = computed(() => {
	return statementDrafts.value === 'true'
})

export const showLegacyPermissions = computed(() => {
	return enableLegacyPermissionsInVue.value === 'true'
})

export const siteScannerVersion = computed(() => Number(configKeys.value?.find(({ keyName }) => keyName === 'SiteScannerVersion').keyValue))

export const cassieIdentityServiceEnabled = computed(() => {
	return cassieIdentityService.value === '1'
})

export const enableScim = computed(() =>
	configKeys.value?.find(({ keyName }) => keyName === 'EnableScim')
		?.keyValue?.toLowerCase() === 'true'
)
